import { FC, ReactNode } from "react";
import { useTheme } from "@mui/material";
import { useAppLink } from "../../../../Hooks/useAppLink";

export interface GridLinkCellProps {
    to: string;
    children: ReactNode;
    /**
     * Always open in a new tab, for the grids configured with `editLinkNewTab` (NG-8661).
     *
     * The href already carries `?ctx`, so the new tab lands in the current organization either way
     * — this only drops the client-side click handler, because there is no in-tab navigation to
     * intercept. `rel` is set because `target="_blank"` otherwise hands the opened page a live
     * `window.opener`.
     */
    newTab?: boolean;
}

const GridLinkCell: FC<GridLinkCellProps> = ({ to, children, newTab = false }) => {
    const link = useAppLink(to);
    const theme = useTheme();
    const style = { color: theme.palette.link.main, textDecoration: "none" };

    if (newTab) {
        return (
            <a href={link.href} target="_blank" rel="noopener noreferrer" style={style}>
                {children}
            </a>
        );
    }

    return (
        <a {...link} style={style}>
            {children}
        </a>
    );
};

export default GridLinkCell;
